import { render, staticRenderFns } from "./ThirdPartyServiceList.vue?vue&type=template&id=0f98baf7"
import script from "./ThirdPartyServiceList.vue?vue&type=script&lang=js"
export * from "./ThirdPartyServiceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports